export const GET_MEMBERS = "GET_MEMBERS";
export const GET_MEMBER_BY_ID = "GET_MEMBER_BY_ID";
export const UPDATE_MEMBER = "UPDATE_MEMBER";
export const DELETE_MEMBER = "DELETE_MEMBER";
export const CREATE_MEMBER = "CREATE_MEMBER";
export const INVITE_MEMBER = "INVITE_MEMBER";
